module.exports = __webpack_public_path__ + "images/decoration_dark.b4a03208.svg";